import {toastService} from "../../../libraries/toast";
import { magazineCategoryService } from "../entity/magazineCategory/MagazineCategoryService";
import {getMagazineCategoriesUseCase} from "./getMagazineCategoriesUseCase";

export const deleteMagazineCategoryUseCase = async (id: number) => {
    try {
        const response = await magazineCategoryService.delete(id);
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            await getMagazineCategoriesUseCase();
        }
    } catch (error) {
        console.warn('deleteMagazineCategoryUseCase: ', error);
        return { isError: true, data: null, message: '' };
    }
}